import { render } from "./BtnFixed.vue?vue&type=template&id=f056bd2a"
import script from "./BtnFixed.vue?vue&type=script&lang=js"
export * from "./BtnFixed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Components/BtnFixed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f056bd2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f056bd2a', __exports__)) {
    api.reload('f056bd2a', __exports__)
  }
  
  module.hot.accept("./BtnFixed.vue?vue&type=template&id=f056bd2a", () => {
    api.rerender('f056bd2a', render)
  })

}


export default __exports__